import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Text } from '../../atoms/text/text';
import styles from './field-footer.module.scss';
/**
 * @deprecated Use `Atoms/FieldFooter` instead.
 */ export const FieldFooter = ({ className, icon: Icon, id, label: fieldFooterLabel, state = 'default' })=>/*#__PURE__*/ _jsxs(Text, {
        className: classNames('field-footer', styles['field-footer'], styles[`state-${state}`], className),
        "data-testid": "field-footer",
        id: id,
        size: "xs",
        children: [
            Icon && /*#__PURE__*/ _jsx("span", {
                className: classNames(styles.icon),
                children: /*#__PURE__*/ _jsx(Icon, {})
            }),
            /*#__PURE__*/ _jsx("span", {
                children: fieldFooterLabel
            })
        ]
    });

//# sourceMappingURL=field-footer.js.map